import "core-js/modules/es.array.filter";
import tim from '../../tim';
var blacklistModule = {
  namespaced: true,
  state: {
    blacklist: []
  },
  mutations: {
    updateBlacklist: function updateBlacklist(state, blacklist) {
      state.blacklist = blacklist;
    },
    removeFromBlacklist: function removeFromBlacklist(state, userID) {
      state.blacklist = state.blacklist.filter(function (item) {
        return item.userID !== userID;
      });
    },
    reset: function reset(state) {
      Object.assign(state, {
        blacklist: []
      });
    }
  },
  actions: {
    getBlacklist: function getBlacklist(context) {
      tim.getBlacklist().then(function (_ref) {
        var data = _ref.data;

        if (data.length > 0) {
          tim.getUserProfile({
            userIDList: data
          }).then(function (_ref2) {
            var data = _ref2.data;
            context.commit('updateBlacklist', data);
          });
        }
      });
    }
  }
};
export default blacklistModule;